import { DriveDeskAIIcon } from "@/components/icons/DriveDeskAIIcon";

/**
 * "Your AI Office Manager" thinking indicator — replaces the generic
 * animated-dots typing indicator with the brand's own signature sparkle
 * motif (per design_guidelines.md `ai_office_manager.thinking_animation`):
 * the icon's two gold sparkles twinkle in a fast, alternating cadence
 * while a response is actively streaming, paired with a short "thinking"
 * label so it's unambiguous this is a status, not a message.
 */
export const AITypingIndicator = () => (
  <div className="flex items-end gap-2" data-testid="ai-thinking-indicator">
    <DriveDeskAIIcon className="h-7 w-7 shrink-0" size="sm" variant="circle" thinking />
    <div className="bg-muted rounded-2xl rounded-bl-sm px-4 py-2.5 flex items-center gap-1.5">
      <span className="text-xs text-muted-foreground">Your AI Office Manager is thinking</span>
      <span aria-hidden="true" className="inline-flex gap-0.5">
        <span className="ai-sparkle-thinking-a text-[hsl(var(--gold-bright))] text-xs leading-none">✦</span>
        <span className="ai-sparkle-thinking-b text-[hsl(var(--gold-bright))] text-xs leading-none">✦</span>
      </span>
    </div>
  </div>
);
